<div class="margins" fxLayout="column">
  <div class="header">
    <div fxLayout="row">
      <div fxLayout="column" fxLayoutAlign="center left">
        <div class="title-text">{{ 'REQUEST_QUOTE.TITLE' | translate }}</div>
        <div class="sub-text">{{ 'REQUEST_QUOTE.DESCRIPTION' | translate }}</div>
      </div>
    </div>
  </div>
  <div class="line"></div>
  <div *ngIf="loading" class="content" fxFlex="100%">
    {{ 'LOADING' | translate }}
  </div>

  <div *ngIf="!loading" class="content" fxFlex="100%">
    <div class="label">{{ 'REQUEST_QUOTE.ID' | translate }}</div>
    <app-isomasters-text-copy [value]="configurationId"></app-isomasters-text-copy>
  </div>

  <app-isomasters-button (modularClick)="share()" [disabled]="loading" class="confirm-button">
    <div class="confirm-button-text" description fxLayout="row" fxLayoutAlign="center center">
      <span class="confirm-link">{{ 'REQUEST_QUOTE.BUTTON' | translate }}</span>
    </div>
  </app-isomasters-button>
</div>
